import Cookies from "js-cookie";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { Button } from "@/components/ui/button/button";
import { getAllAttendanceRequestOfEmployeeByAdminQueryOptions } from "@/config/queries/query-options";

export const EmployeeAttendanceRequests = () => {
  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;

  const { data } = useQuery(
    getAllAttendanceRequestOfEmployeeByAdminQueryOptions(key, {
      employee: empId,
      status: "Pending",
    })
  );

  return (
    <div className="w-60 min-h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Pending Attendance Requests</h2>

        <span className="shrink-0 text-lg">{data?.requests?.length || 0}</span>
      </div>
      <div className="">
        <Button variant="default" size="sm" asChild>
          <Link to={`/admin/employee-attendance-requests`}>Go</Link>
        </Button>
      </div>
    </div>
  );
};
